import {IndexFilters, type CheckboxGroupProps} from '../../IndexTemplate/components/IndexFilters/IndexFilters'

type AsideProps = {
  topics: Array<{
    id: string
    preferred_label: string
  }>
  selectedTopicIds?: string[]
}

export const Aside = ({topics, selectedTopicIds}: AsideProps) => {
  const checkboxGroups: CheckboxGroupProps[] = [
    {
      value: 'topic',
      label: 'Topic',
      checkboxes: topics.map(topic => ({
        label: topic.preferred_label,
        value: topic.id,
        isChecked: (selectedTopicIds || []).includes(topic.id),
      })),
    },
  ]

  return <IndexFilters checkboxGroups={checkboxGroups} />
}
